import React, { Component } from 'react';
import './SelectBindCardPopup.less';
import { Flex, Modal, Toast } from 'antd-mobile';
import cx from 'classnames';
import CommonBtn from 'pubBiz/CommonBtn/CommonBtnView';
import Stores from 'config/Stores';
import utils from 'utils';
import SelectBindCardCodeMod from './SelectBindCardCodeMod';

const Radio = (props) => {
  const { checked, disabled, onClick } = props;
  let scr = '';
  if (disabled) {
    if (checked) {
      scr = '/assets/imgs/widget/CheckBox/icon-checked-disable.svg';
    } else {
      scr = '/assets/imgs/widget/CheckBox/icon-unchecked-disable.svg';
    }
  } else {
    if (checked) {
      scr = '/assets/imgs/widget/Radio/icon-checked.png';
    } else {
      scr = '/assets/imgs/widget/Radio/icon-unchecked.png';
    }
  }

  return scr.indexOf('assets') >= 0 ? (
    <img
      src={CDN_BASE + scr}
      className="common-checkbox"
      onClick={(e) => {
        if (!disabled) {
          onClick && onClick(e);
        }
      }}
    />
  ) : (
    <span className={`iconfont ${scr}`} />
  );
};

/**
 * 首页半屏弹窗：享脉登录时存在多张会员卡，由用户选择绑定卡号
 * 数据来源 sessionStorage（bindUserList / hasWechatAuth / bindAuthCode）
 */
export default class SelectBindCardPopup extends Component {
  constructor(props) {
    super(props);
    const bindUserListStr = sessionStorage.getItem('bindUserList');
    let bindUserList = [];
    let wechatData = {};
    let authCode = '';
    // 仅在享脉(isXM)登录多卡场景展示半屏弹窗，避免其它渠道残留 bindUserList 时误弹
    if (bindUserListStr && utils.isXM()) {
      try {
        bindUserList = JSON.parse(bindUserListStr) || [];
        wechatData = JSON.parse(sessionStorage.getItem('hasWechatAuth') || '{}') || {};
        authCode = sessionStorage.getItem('bindAuthCode') || '';
      } catch (error) {
        bindUserList = [];
      }
    }
    this.state = {
      visible: !!bindUserList.length,
      selectCardCode: '',
      bindUserList,
      wechatData,
      authCode
    };
    this.store = new SelectBindCardCodeMod();
    this.appStore = Stores.AppMod;
  }

  clearData = () => {
    sessionStorage.removeItem('bindUserList');
    sessionStorage.removeItem('bindAuthCode');
  };

  onClose = () => {
    this.setState({ visible: false });
    this.clearData();
  };

  confirmBindCard = () => {
    try {
      const { bindUserList, selectCardCode, wechatData, authCode } = this.state;
      if (!selectCardCode) {
        Toast.fail('请选择卡号', 1);
        return;
      }

      const loginChannel = utils.isXM() ? 23 : 4;
      const selectCardInfo = bindUserList.find((item) => item.cardCode === selectCardCode) || {};
      const params = {
        wxChatId: selectCardInfo.id || wechatData.wxChatId,
        userId: selectCardInfo.userId,
        loginChannel,
        auth: authCode || '',
        cardCode: selectCardInfo.cardCode || '',
        openId: wechatData.openId || '',
        thirdToken: wechatData.thirdToken || ''
      };
      const serUrl = utils.isXM() ? 'xiangMaiSilent' : 'workAuthBind';
      Toast.loading();
      this.store[serUrl](params).then((res) => {
        Toast.hide();
        this.setState({ visible: false });
        if (res) {
          const { data } = res;
          if (data.token) {
            this.appStore.saveLoginInfo(data).then(() => {
              const { userInfo } = this.appStore;
              const { belongSystem } = userInfo || {};
              if (belongSystem == 'KER') {
                this.appStore.setKerUpdateHealth();
              }
              this.setState({ visible: false });
              this.clearData();
              utils.gotoPage();
            });
            return;
          }
        }

        this.clearData();
        utils.gotoPage();
      });
    } catch (err) {
      Toast.hide();
      this.setState({ visible: false });
      this.clearData();
      utils.gotoPage();
    }
  };

  render() {
    const { visible, bindUserList, selectCardCode, wechatData } = this.state;
    if (!visible) {
      return null;
    }
    return (
      <Modal
        className="selectBindCardPopup"
        wrapClassName="selectBindCardPopupWrap"
        visible={visible}
        popup
        animationType="slide-up"
        maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.55)' }}
        maskClosable={false}
        onClose={this.onClose}>
        <div className="popup-body">
          <div className="popup-header">
            <div>
              <p className="popup-title">请选择您的卡号进行登录</p>
              <p className="popup-tip">{wechatData.phone || ''} 关联多张会员卡号</p>
            </div>
            {/* <span className="iconfont icon-close2 popup-close" onClick={this.onClose} /> */}
          </div>

          <div className="card-list">
            {bindUserList.map((item, index) => {
              const isSelected = item.cardCode === selectCardCode;
              return (
                <Flex
                  align="center"
                  justify="between"
                  direction="row"
                  key={`card-list-${index}`}
                  className={cx('card-item', { 'card-item-selected': isSelected })}
                  onClick={() => {
                    this.setState({ selectCardCode: item.cardCode });
                  }}>
                  <p>{item.cardCode}</p>
                  <Radio checked={isSelected} />
                </Flex>
              );
            })}
          </div>
          <CommonBtn title="确认" className="confirm-btn" onClick={this.confirmBindCard} />
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/WechatAuth/SelectBindCardCode/SelectBindCardPopup.js